import { create } from "zustand"

import type { UpdateSubmissionItemInput } from "@/graphql/codegen/graphql"

interface SubmissionUpdatesState {
  submissionId: string | null
  itemsByCustomerRowId: Record<string, UpdateSubmissionItemInput>
}

interface SubmissionUpdatesActions {
  setSubmission: (submissionId: string) => void
  captureItems: (items: UpdateSubmissionItemInput[]) => void
  getMergedItems: (currentPageItems: UpdateSubmissionItemInput[]) => UpdateSubmissionItemInput[]
  clear: () => void
}

const INITIAL_STATE: SubmissionUpdatesState = {
  submissionId: null,
  itemsByCustomerRowId: {},
}

export const useSubmissionUpdatesStore = create<SubmissionUpdatesState & SubmissionUpdatesActions>((set, get) => ({
  ...INITIAL_STATE,

  setSubmission: (submissionId) =>
    set((state) => (state.submissionId === submissionId ? state : { submissionId, itemsByCustomerRowId: {} })),

  captureItems: (items) =>
    set((state) => {
      if (!items.length) return state
      const nextItems = { ...state.itemsByCustomerRowId }
      for (const item of items) {
        nextItems[item.customerRowId] = item
      }
      return { itemsByCustomerRowId: nextItems }
    }),

  // Mounted tables are the freshest source for their own customer rows, so they win
  // over anything captured when their page was last left.
  getMergedItems: (currentPageItems) => {
    const merged = { ...get().itemsByCustomerRowId }
    for (const item of currentPageItems) {
      merged[item.customerRowId] = item
    }
    return Object.values(merged)
  },

  clear: () => set(INITIAL_STATE),
}))
